import { SxProps, Theme } from "@mui/material";

export const gradientText: SxProps<Theme> = {
  background: "linear-gradient(90deg, #51F2CB 0%, #20C2F1 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

export const eyebrow: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.75rem",
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase" as const,
  color: "#51F2CB",
  mb: 2,
};

export const heroSection: SxProps<Theme> = {
  minHeight: "100vh",
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  px: 2,
  overflow: "hidden",
  "@keyframes fadeUp": {
    from: { opacity: 0, transform: "translateY(32px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
};

export const heroFlatOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "rgba(5,12,35,0.1)",
  pointerEvents: "none",
};

export const heroRadialOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background:
    "radial-gradient(ellipse 70% 65% at 50% 50%, rgba(5,12,35,0.68) 0%, rgba(5,12,35,0.3) 55%, transparent 80%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const heroTopGradient: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: "160px",
  background: "linear-gradient(to bottom, rgba(5,12,35,0.55), transparent)",
  zIndex: 1,
  pointerEvents: "none",
};

export const heroBottomGradient: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "220px",
  background: "linear-gradient(to top, #040922 0%, rgba(4,9,34,0.85) 40%, transparent 100%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const heroEyebrow: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.75rem",
  fontWeight: 600,
  letterSpacing: "0.2em",
  textTransform: "uppercase" as const,
  color: "#51F2CB",
  mb: 2,
  animation: "fadeUp 0.7s ease 0.1s both",
};

export const heroHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.4rem", md: "4rem" },
  color: "white",
  lineHeight: 1.1,
  mb: 3,
  animation: "fadeUp 0.7s ease 0.25s both",
};

export const heroSubheading: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1.05rem", md: "1.25rem" },
  color: "rgba(255,255,255,0.82)",
  mb: 5,
  maxWidth: 680,
  mx: "auto",
  animation: "fadeUp 0.7s ease 0.4s both",
};

export const ctaButton: SxProps<Theme> = {
  background: "linear-gradient(90deg, #f97316, #fb923c)",
  color: "white",
  borderRadius: "50px",
  px: 5,
  py: 1.75,
  fontSize: "1rem",
  fontWeight: 700,
  fontFamily: "'Barlow', sans-serif",
  textTransform: "none",
  boxShadow: "0 4px 24px rgba(249,115,22,0.35)",
  "&:hover": {
    background: "linear-gradient(90deg, #ea6c0a, #f97316)",
    color: "white",
  },
};

export const valuePropSection: SxProps<Theme> = {
  background: "#040922",
  pt: { xs: 6, md: 8 },
  pb: { xs: 6, md: 8 },
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: "center",
  overflow: "hidden",
};

export const valuePropTextWrapper: SxProps<Theme> = {
  flex: 1,
  pl: { xs: 4, md: 8, lg: 16 },
  pr: { xs: 4, md: 6, lg: 10 },
  py: { xs: 6, md: 0 },
};

export const sectionHeadingLarge: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.5rem", md: "4rem" },
  color: "white",
  mb: 4,
  lineHeight: 1.15,
};

export const sectionBodyText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1.05rem", md: "1.2rem" },
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.75,
};

export const valuePropImageWrapper: SxProps<Theme> = {
  flex: "0 0 auto",
  width: { xs: "100%", md: "50%" },
  alignSelf: "stretch",
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "flex-end",
  overflow: "hidden",
  ml: "-4px",
};

export const valuePropImage: SxProps<Theme> = {
  width: "120%",
  maxWidth: { xs: "100%", md: "900px" },
  display: "block",
  objectFit: "contain",
  objectPosition: "right bottom",
};

export const flexibilitySection: SxProps<Theme> = {
  background: "#040922",
  pt: { xs: 6, md: 8 },
  pb: { xs: 12, md: 18 },
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: "center",
  overflow: "hidden",
  gap: 0,
};

export const flexibilityVideoWrapper: SxProps<Theme> = {
  flex: "0 0 auto",
  width: { xs: "100%", md: "calc(48% + 4px)" },
  alignSelf: "stretch",
  background: "#040922",
  mr: "-4px",
};

export const flexibilityVideo: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center",
  display: "block",
  border: "none",
  outline: "none",
};

export const flexibilityTextWrapper: SxProps<Theme> = {
  flex: 1,
  pl: { xs: 4, md: 8, lg: 12 },
  pr: { xs: 4, md: 10, lg: 16 },
  py: { xs: 6, md: 0 },
  background: "#040922",
};

export const compensationHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.5rem", md: "4rem" },
  color: "white",
  mb: 3,
  lineHeight: 1.15,
};

export const compensationBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "1.05rem",
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.75,
  mb: 4,
};

export const compensationCard = (inView: boolean, delay: number): SxProps<Theme> => ({
  position: "relative",
  overflow: "hidden",
  background: "#0b1120",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "20px",
  p: 3.5,
  display: "flex",
  flexDirection: "column",
  minHeight: 220,
  height: "100%",
  opacity: inView ? 1 : 0,
  transform: inView ? "translateY(0)" : "translateY(32px)",
  transition: `opacity 0.7s ease ${delay}s, transform 0.7s ease ${delay}s`,
});

export const compensationCardGlow = (index: number): SxProps<Theme> => ({
  position: "absolute",
  ...(index === 0 && { top: -80, left: -80 }),
  ...(index === 1 && { top: -80, right: -80 }),
  ...(index === 2 && { bottom: -80, left: "50%", transform: "translateX(-50%)" }),
  width: 320,
  height: 320,
  background:
    "radial-gradient(circle, rgba(81,242,203,0.20) 0%, rgba(81,242,203,0.08) 40%, rgba(81,242,203,0.02) 65%, transparent 75%)",
  pointerEvents: "none",
});

export const compensationCardNumber: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.78rem",
  fontWeight: 600,
  color: "rgba(255,255,255,0.25)",
  letterSpacing: "0.08em",
};

export const compensationCardIconBox: SxProps<Theme> = {
  width: 44,
  height: 44,
  borderRadius: "12px",
  background: "rgba(81,242,203,0.10)",
  border: "1px solid rgba(81,242,203,0.20)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const compensationCardTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  fontSize: "1rem",
  color: "white",
  mb: 0.75,
};

export const compensationCardDescription: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.88rem",
  color: "rgba(255,255,255,0.60)",
  lineHeight: 1.65,
};

export const projectManagementSection: SxProps<Theme> = {
  background: "linear-gradient(to bottom, #040922 0%, #0d1526 100%)",
  pt: { xs: 8, md: 10 },
  pb: { xs: 12, md: 18 },
};

export const sectionHeadingMedium: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "3rem" },
  color: "white",
  mb: 4,
  lineHeight: 1.15,
};

export const sectionBodyCentered: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1.05rem", md: "1.2rem" },
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.75,
  mb: 6,
};

export const pillChip: SxProps<Theme> = {
  position: "relative",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  gap: 1.25,
  px: 3,
  py: 1.5,
  background: "#0b1120",
  border: "1px solid rgba(81,242,203,0.2)",
  borderRadius: "14px",
  boxShadow: "0 0 18px rgba(81,242,203,0.06)",
};

export const pillChipGlow: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "radial-gradient(ellipse at top left, rgba(81,242,203,0.08) 0%, transparent 65%)",
  pointerEvents: "none",
};

export const pillChipLabel: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontSize: "0.95rem",
  fontWeight: 600,
  color: "white",
  position: "relative",
};

export const closeDealsSection: SxProps<Theme> = {
  position: "relative",
  py: { xs: 12, md: 18 },
  overflow: "hidden",
  backgroundImage: "url('/img/assets/House-texas.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "right center",
};

export const closeDealsOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background: "linear-gradient(to right, #0d1526 30%, rgba(13,21,38,0.85) 60%, rgba(13,21,38,0.3) 100%)",
  zIndex: 0,
  pointerEvents: "none",
};

export const closeDealsTopGradient: SxProps<Theme> = {
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  height: "180px",
  background: "linear-gradient(to bottom, #0d1526 0%, transparent 100%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const closeDealsBottomGradient: SxProps<Theme> = {
  position: "absolute",
  bottom: 0,
  left: 0,
  right: 0,
  height: "180px",
  background: "linear-gradient(to top, #0d1526 0%, transparent 100%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const closeDealsHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "3rem" },
  color: "white",
  lineHeight: 1.15,
};

export const closeDealsBody = (inView: boolean): SxProps<Theme> => ({
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1.05rem", md: "1.2rem" },
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.75,
  textAlign: "left",
  mb: 6,
  maxWidth: 520,
  opacity: inView ? 1 : 0,
  transform: inView ? "translateY(0)" : "translateY(32px)",
  transition: "opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s",
});

export const closeDealsCard = (inView: boolean, delay: number): SxProps<Theme> => ({
  position: "relative",
  overflow: "hidden",
  background: "#0b1120",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "20px",
  p: { xs: 4, md: 5 },
  height: "100%",
  opacity: inView ? 1 : 0,
  transform: inView ? "translateY(0)" : "translateY(32px)",
  transition: `opacity 0.7s ease ${delay}s, transform 0.7s ease ${delay}s`,
});

export const closeDealsCardGlow = (index: number): SxProps<Theme> => ({
  position: "absolute",
  ...(index === 0 ? { top: -60, left: -60 } : { bottom: -60, right: -60 }),
  width: 260,
  height: 260,
  background:
    "radial-gradient(circle, rgba(81,242,203,0.18) 0%, rgba(81,242,203,0.07) 40%, rgba(81,242,203,0.02) 65%, transparent 75%)",
  pointerEvents: "none",
});

export const closeDealsCardIconBox: SxProps<Theme> = {
  width: 48,
  height: 48,
  borderRadius: "12px",
  background: "rgba(81,242,203,0.08)",
  border: "1px solid rgba(81,242,203,0.18)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  mb: 2.5,
};

export const closeDealsCardTitle: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 700,
  fontSize: "1.35rem",
  color: "white",
  mb: 2,
};

export const closeDealsCardBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "1.05rem",
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.7,
};

export const featuresSection: SxProps<Theme> = {
  background: "linear-gradient(to bottom, #0d1526 0%, #050c23 100%)",
  py: { xs: 14, md: 22 },
  px: { xs: 2, md: 4 },
};

export const featuresHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "3rem" },
  color: "white",
  lineHeight: 1.15,
};

export const featureCard = (inView: boolean, delay: number): SxProps<Theme> => ({
  position: "relative",
  overflow: "hidden",
  background: "#0b1120",
  border: "1px solid rgba(255,255,255,0.08)",
  borderRadius: "16px",
  p: { xs: 3, md: 3.5 },
  display: "flex",
  flexDirection: "column",
  gap: 1.5,
  height: "100%",
  opacity: inView ? 1 : 0,
  transform: inView ? "translateY(0)" : "translateY(32px)",
  transition: `opacity 0.7s ease ${delay}s, transform 0.7s ease ${delay}s`,
});

export const featureCardGlowTopLeft: SxProps<Theme> = {
  position: "absolute",
  top: -60,
  left: -60,
  width: 200,
  height: 200,
  background: "radial-gradient(circle, rgba(81,242,203,0.15) 0%, rgba(81,242,203,0.05) 50%, transparent 70%)",
  pointerEvents: "none",
};

export const featureCardGlowBottomRight: SxProps<Theme> = {
  position: "absolute",
  bottom: -60,
  right: -60,
  width: 200,
  height: 200,
  background: "radial-gradient(circle, rgba(81,242,203,0.15) 0%, rgba(81,242,203,0.05) 50%, transparent 70%)",
  pointerEvents: "none",
};

export const featureCardGlowTopRight: SxProps<Theme> = {
  position: "absolute",
  top: -60,
  right: -60,
  width: 200,
  height: 200,
  background: "radial-gradient(circle, rgba(81,242,203,0.15) 0%, rgba(81,242,203,0.05) 50%, transparent 70%)",
  pointerEvents: "none",
};

export const featureCardGlowBottomLeft: SxProps<Theme> = {
  position: "absolute",
  bottom: -60,
  left: -60,
  width: 200,
  height: 200,
  background: "radial-gradient(circle, rgba(81,242,203,0.15) 0%, rgba(81,242,203,0.05) 50%, transparent 70%)",
  pointerEvents: "none",
};

export const featureCardIconBox: SxProps<Theme> = {
  width: 40,
  height: 40,
  borderRadius: "10px",
  background: "rgba(81,242,203,0.08)",
  border: "1px solid rgba(81,242,203,0.15)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

export const featureCardLabel: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 600,
  fontSize: { xs: "0.88rem", md: "0.95rem" },
  color: "rgba(255,255,255,0.88)",
  lineHeight: 1.4,
};

export const featuresMockupWrapper: SxProps<Theme> = {
  flex: "0 0 auto",
  width: { xs: 180, md: 420 },
  alignSelf: "stretch",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const featuresMockupImage: SxProps<Theme> = {
  width: "100%",
  height: "100%",
  objectFit: "contain",
  objectPosition: "center",
  display: "block",
};

export const paymentsSection: SxProps<Theme> = {
  background: "linear-gradient(to bottom, #050c23 0%, #0a0f1e 100%)",
  pt: { xs: 8, md: 10 },
  pb: { xs: 12, md: 18 },
};

export const paymentsHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "3rem" },
  color: "white",
  mb: 4,
  lineHeight: 1.15,
};

export const paymentsBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1.05rem", md: "1.2rem" },
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.75,
  mb: 6,
};

export const trainingSection: SxProps<Theme> = {
  background: "linear-gradient(to bottom, #050c23 0%, #0a0f1e 100%)",
  pt: { xs: 12, md: 18 },
  pb: 0,
  overflow: "hidden",
};

export const trainingLayout: SxProps<Theme> = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  alignItems: "flex-start",
  gap: { xs: 6, md: 10 },
};

export const trainingImageWrapper: SxProps<Theme> = {
  flex: "0 0 auto",
  width: { xs: "100%", md: "45%" },
  display: "flex",
  alignItems: "flex-end",
};

export const trainingImage: SxProps<Theme> = {
  width: "100%",
  display: "block",
  objectFit: "contain",
  objectPosition: "bottom",
};

export const trainingHeading: SxProps<Theme> = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2rem", md: "3rem" },
  color: "white",
  mb: 3,
  lineHeight: 1.15,
};

export const trainingBody: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1.05rem", md: "1.1rem" },
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.75,
  mb: 4,
};

export const trainingCard = (inView: boolean): SxProps<Theme> => ({
  position: "relative",
  overflow: "hidden",
  background: "#0b1120",
  border: "1px solid rgba(81,242,203,0.2)",
  borderRadius: "14px",
  p: 3,
  display: "flex",
  alignItems: "center",
  gap: 2,
  boxShadow: "0 0 18px rgba(81,242,203,0.06)",
  opacity: inView ? 1 : 0,
  transform: inView ? "translateY(0)" : "translateY(32px)",
  transition: "opacity 0.7s ease 0.2s, transform 0.7s ease 0.2s",
});

export const trainingCardIconBox: SxProps<Theme> = {
  flexShrink: 0,
  width: 44,
  height: 44,
  borderRadius: "10px",
  background: "rgba(81,242,203,0.08)",
  border: "1px solid rgba(81,242,203,0.18)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const trainingCardText: SxProps<Theme> = {
  fontFamily: "'Barlow', sans-serif",
  fontSize: "1rem",
  color: "rgba(255,255,255,0.82)",
  lineHeight: 1.6,
  fontWeight: 500,
  position: "relative",
};

export const ctaSection: SxProps<Theme> = {
  position: "relative",
  background: "linear-gradient(to bottom, #0a0f1e 0%, #050c23 100%)",
  py: { xs: 16, md: 24 },
  overflow: "hidden",
};

export const ctaBackgroundImage: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  backgroundImage: "url('/img/assets/Neighborhood_Solar.jpg')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  opacity: 0.55,
  zIndex: 0,
};

export const ctaVignetteOverlay: SxProps<Theme> = {
  position: "absolute",
  inset: 0,
  background:
    "radial-gradient(ellipse 75% 90% at 50% 50%, rgba(5,12,35,0.88) 0%, rgba(5,12,35,0.6) 45%, rgba(5,12,35,0.2) 70%, transparent 90%)",
  zIndex: 1,
  pointerEvents: "none",
};

export const ctaHeading = (inView: boolean): SxProps<Theme> => ({
  fontFamily: "'Poppins', sans-serif",
  fontWeight: 800,
  fontSize: { xs: "2.2rem", md: "3.5rem" },
  color: "white",
  mb: 3,
  lineHeight: 1.1,
  opacity: inView ? 1 : 0,
  transform: inView ? "translateY(0)" : "translateY(32px)",
  transition: "opacity 0.7s ease 0.15s, transform 0.7s ease 0.15s",
});

export const ctaBody = (inView: boolean): SxProps<Theme> => ({
  fontFamily: "'Barlow', sans-serif",
  fontSize: { xs: "1.05rem", md: "1.2rem" },
  color: "rgba(255,255,255,0.82)",
  mb: 5,
  opacity: inView ? 1 : 0,
  transform: inView ? "translateY(0)" : "translateY(32px)",
  transition: "opacity 0.7s ease 0.2s, transform 0.7s ease 0.2s",
});

export const ctaDisclaimer = (inView: boolean): SxProps<Theme> => ({
  fontFamily: "'Barlow', sans-serif",
  fontSize: "0.9rem",
  color: "rgba(255,255,255,0.6)",
  mt: 3,
  opacity: inView ? 1 : 0,
  transform: inView ? "translateY(0)" : "translateY(32px)",
  transition: "opacity 0.7s ease 0.3s, transform 0.7s ease 0.3s",
});
